export type ChecklistItem = { value: string; family: string };

export const GENERIC_CHECKLIST_EMOJI = '📋';

export const STATIC_CHECKLIST_ITEMS: ChecklistItem[] = [
  {
    value: 'Carte vitale',
    family: 'CARTE',
  },
];

export const DEFAULT_CHECKLIST_ITEMS: ChecklistItem[] = [
  ...STATIC_CHECKLIST_ITEMS,
  {
    value: 'Carnet de santé',
    family: 'CARNET',
  },
  {
    value: "Résultat d'examens",
    family: 'RESULTAT',
  },
  {
    value: 'Dernières ordonnances',
    family: 'ORDONNANCE',
  },
];

// Families the app recognizes. Raw KB families may carry suffixes
// (e.g. "CARTE_VITALE"), so we always match by prefix, never equality.
export const KNOWN_CHECKLIST_FAMILIES = [
  'CARTE',
  'CARNET',
  'RESULTAT',
  'ORDONNANCE',
] as const;

export type KnownChecklistFamily = (typeof KNOWN_CHECKLIST_FAMILIES)[number];

// Canonical known family for a raw KB family string, or null for the generic
// "autre" bucket (any unlisted family).
export const resolveChecklistFamily = (
  family: string,
): KnownChecklistFamily | null =>
  KNOWN_CHECKLIST_FAMILIES.find((known) => family.startsWith(known)) ?? null;

export const FAMILY_EMOJI: Record<KnownChecklistFamily, string> = {
  CARTE: '✅',
  CARNET: '📔',
  RESULTAT: '📊',
  ORDONNANCE: '📝',
};

export const resolveChecklistEmoji = (item: ChecklistItem): string => {
  const known = resolveChecklistFamily(item.family);
  return known ? FAMILY_EMOJI[known] : GENERIC_CHECKLIST_EMOJI;
};

export const buildChecklistItems = (
  questionnaireChecklistItems: unknown,
): ChecklistItem[] =>
  Array.isArray(questionnaireChecklistItems)
    ? [
        ...STATIC_CHECKLIST_ITEMS,
        ...(questionnaireChecklistItems as ChecklistItem[]),
      ]
    : DEFAULT_CHECKLIST_ITEMS;
